import classNames from 'classnames'
import Translate from 'modules/local/Translate'
import React from 'react'

const HeaderItemInfo = ({
                            style,
                            title,
                            children,
                            className,
                            renderTitle,
                            divider = true,
                            hidden = false,
                            extra,
                        }) => {
    if (Boolean(hidden)) return null
    return (
        <Translate>
            {(t) => (
                <div className="w-full flex flex-col gap-3">
                    <div className="flex items-center">
                        <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                          {renderTitle ? renderTitle(t) : t(title)}
                        </h3>
                        {!!divider && <span className="border-b w-full flex-1 my-3 ml-3"/>}
                        {extra}
                    </div>
                    <div
                        style={style}
                        className={classNames('ml-0 md:ml-3', className)}>
                        {children}
                    </div>
                </div>
            )}
        </Translate>
    )
}

export default HeaderItemInfo
